
import React, { Component } from 'react';
import ThirdCom from '../ThirdCom';
const billTypeEnum = ["grid", "extcard", "card", "form"];

/**
 * 嵌入式分析
 */
class EmbedGraphic extends Component {

    static defaultProps = { visible: true }

    render() {
        let { 
            _pageScope,
            pageCode,
            appCode,
            metaData = [],
            billType:billTypeProp,
            searchId:searchIdProp,
            pkname:pknameProp,
            headId:headIdProp,
            bodyId: bodyIdProp,
        } = this.props; 
        let { meta } = _pageScope.props;
        //设计器没配置的属性需要从meta中解析
        let { billtype, head = {}, body = [], relation = [], headcode } = metaData;
        //解析billtype
        if(!billTypeProp){
            billTypeProp = billtype;
        }
        //解析headId
        if(!headIdProp){
            headIdProp = headcode || relation.find(x => x.clazz === head.clazz)?.areacode;
        }
        if(billTypeProp === billTypeEnum[0]){
            //列表类型解析searchId
            if(!searchIdProp){
                let metaData = meta.getMeta();
                searchIdProp = Object.values(metaData).find( x=> x !== null && typeof x === "object" && x.moduletype === "search")?.code;
            }
            //列表类型解析pkname
            if(!pknameProp){
                pknameProp = head.pk;
            }                             
        }else{
            //卡片类型解析bodyId数组
            if(!Array.isArray(bodyIdProp) || (Array.isArray(bodyIdProp) && bodyIdProp.length === 0)){
                bodyIdProp = body.map(x => relation.find(item=> item.clazz === x.clazz)?.areacode).filter(x => x);
            }
        }
        
        return <ThirdCom
            {...this.props}
            showThirdComponent={this.props.visible}
            componentNameSpace="embedGraphic"
            componentPath="../../../../lappreportrt/embedGraphic/embedGraphic.js"
            appcode={appCode}
            pagecode={pageCode}
            billType={billTypeProp}
            searchId={searchIdProp}
            pkname={pknameProp}
            bodyId={bodyIdProp}
            headId={headIdProp}
            _this = {{ props:  _pageScope.props }}
            componentName='嵌入式分析'
            showPlaceHolder={true}
        />;
    }
}

export default EmbedGraphic;
